import {useMemo} from 'react';

import {noop} from 'lodash';

import {useDocumentEventHandler} from '~/shared/hooks';
import FocusTrapDiv from '~/shared/components/FocusTrapDiv';
import usePreventBodyScrolling from '~/shared/hooks/usePreventBodyScrolling';

import DropdownButton from './DropdownButton';
import {DropdownWrapper, DropdownContentContainer} from './styled.components';

const DropdownContainer = ({
  isOpen = false,
  startIcon,
  showArrow,
  buttonTitle,
  onDropdownClick = noop,
  closeDropdown = noop,
  children,
  isMaxLargeMobile,
  className = '',
  useFocusTrap = true,
}) => {
  const isDropdownOpen = useMemo(() => children && isOpen, [children, isOpen]);

  const onKeyPressed = e => {
    if (e.key === 'Escape') {
      closeDropdown();
    }
  };

  useDocumentEventHandler('keydown', onKeyPressed);

  usePreventBodyScrolling({shouldPreventScroll: !!isDropdownOpen});

  const WrapperComponent = useFocusTrap && isOpen ? FocusTrapDiv : 'div';

  return (
    <WrapperComponent>
      <DropdownWrapper className={className} onClickOutside={closeDropdown}>
        <DropdownButton
          showArrow={showArrow}
          startIcon={startIcon}
          isOpen={isDropdownOpen}
          onDropdownClick={onDropdownClick}
          buttonTitle={buttonTitle}
          isMaxLargeMobile={isMaxLargeMobile}
        />
        {isDropdownOpen && (
          <>
            <DropdownContentContainer>
              {children}
            </DropdownContentContainer>
          </>
        )}
      </DropdownWrapper>
    </WrapperComponent>
  );
};

export default DropdownContainer;
